"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ReactView = _interopRequireDefault(require("../ReactView"));

var _reactRedux = require("react-redux");

var _backbone = _interopRequireDefault(require("backbone.marionette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatefulReactView = function (View) {
  if (View === void 0) {
    View = _backbone.default.ItemView;
  }

  var RV = (0, _ReactView.default)(View);
  return RV.extend({
    initialize: function initialize(_ref) {
      var store = _ref.store;
      View.prototype.initialize.apply(this, arguments);
      this.__store = store;
    },
    renderComponent: function renderComponent() {
      return _react.default.createElement(_reactRedux.Provider, {
        store: this.__store
      }, this.template());
    },
    render: function render() {
      this._ensureElement();

      this._triggerBeforeRendered();

      var isRerender = !!this._component;
      this._component = this.renderComponent();

      if (isRerender) {
        // If we are re-rendering, we want to call ReactDOM.render() to refresh
        this.mountComponent();
      }

      this._triggerRendered();
    }
  });
};

var _default = StatefulReactView;
exports.default = _default;